<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill:currentColor" viewBox="0 0 12 13" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M7.368.226a1 1 0 0 0-1.414.15L3.058 4.004h1.28L6.735 1l.77.629-1.93 2.375h1.288L8.28 2.26l1.718 1.403-.298.34h.3a3 3 0 0 1 .88.132 1 1 0 0 0-.25-1.245zM1 4.504a.5.5 0 0 1 .5-.5h.558l.795-1H1.5a1.5 1.5 0 0 0-1.5 1.5v6a2.5 2.5 0 0 0 2.5 2.5H10a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H1.5a.5.5 0 0 1-.5-.5m7.5 4.5h1a.5.5 0 1 1 0 1h-1a.5.5 0 1 1 0-1"
	/>
</svg>
